import Layout from "../../components/layout/Layout";
import { useTranslation } from "react-i18next";
import {  useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import i18n from "../../i18n";
import SeoHead from "../../components/elements/SeoHead";

const PublicOfferEn = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();


    useEffect(() => {
      const handleLanguageChange = () => {
        navigate(`/${i18n.language}/public-offer`)
      };
  
      i18n.on("languageChanged", handleLanguageChange);
      return () => {
        i18n.off("languageChanged", handleLanguageChange);
      };
    }, []);
    return (
        <Layout headerStyle={1} footerStyle={2} >
            <SeoHead metaKey="seo.publicOffer" />
            <div className="container" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 30 }}>
                <h2 style={{ textTransform: "none", marginBottom:20 }}>Public Offer Agreement for Project Management Services via the SkTech Platform</h2>
                <p>This document is a public offer and public agreement addressed to users for entering into an agreement for the provision of project management services via the SkTech platform (hereinafter referred to as the “Platform”). By using the Platform and making a subscription payment, the User automatically accepts the terms of this Agreement.</p>
                <p>According to the provisions of Articles 633, 641 of the Civil Code of Ukraine, the terms of the public offer and the public agreement are the same for all users. In accordance with part 2 of Article 642 of the Civil Code of Ukraine, registration on the SkTech platform (http://sktech.com.ua) is the acceptance of this offer, which is equivalent to the conclusion of the agreement on the terms set forth below, as well as in accordance with the Privacy Policy. The Privacy Policy governs the processing of personal data of users. The terms of the Privacy Policy can be found via the link on our platform. The Privacy Policy is an integral part of these terms.</p>

                <h3>1. General Provisions</h3>
                <p>1.1. This Agreement regulates the relationship between the SkTech Platform, LLC “SUNPOINT IT SOLUTIONS” (hereinafter referred to as the “Administration”), and the user (hereinafter referred to as the “User”), which are concluded on the basis of acceptance of the offer.</p>
                <p>1.2. This Agreement is an official proposal from the Administration for the conclusion of a contract on the terms set forth below.</p>
                <p>1.3. Using the Platform means the User’s full agreement with all terms of the Agreement.</p>

                <h3>2. Subject of the Agreement</h3>
                <p>2.1. The Administration provides the User with access to the platform for project management (hereinafter referred to as the “Service”) on a subscription basis, and the User agrees to pay the corresponding fee.</p>
                <p>2.2. Access to the Service is provided in exchange for payment of the chosen subscription: monthly or annual.</p>

                <h3>3. Procedure for Conclusion of the Agreement</h3>
                <p>3.1. The Agreement is considered concluded from the moment the User accepts the offer by making a subscription payment on the Platform.</p>
                <p>3.2. Acceptance (acceptance) of the offer means the full and unconditional acceptance of all terms of the Agreement without any exceptions.</p>

                <h3>4. Rights and Obligations of the Parties</h3>
                <ul style={{ paddingLeft: "2rem" }}>
                    <li style={{ paddingBottom: 10 }}><strong>4.1. Obligations of the Administration:</strong>
                        <ul>
                            <li>Provide access to the platform for project management according to the selected subscription;</li>
                            <li>Ensure the proper technical state of the Service for stable operation;</li>
                            <li>Respond to requests and resolve issues that arise during the use of the Service.</li>
                        </ul>
                    </li>
                    <li><strong>4.2. Obligations of the User:</strong>
                        <ul>
                            <li>Comply with the terms of this Agreement and the Privacy Policy;</li>
                            <li>Provide only accurate information during registration;</li>
                            <li>Not share their access details to the Service with third parties.</li>
                        </ul>
                    </li>
                </ul>

                <h3>5. Service Fees and Payment Procedure</h3>
                <p>5.1. The subscription fee is published on the Platform in USD. The price in UAH is determined by the payment system’s conversion rate on the day of payment:</p>
                <ul>
                    <li>Starter Plan: 10 USD per month or 100 USD per year (equivalent in UAH — according to the payment system’s rate at the time of payment);</li>
                    <li>Comfort Plan: 25 USD per month or 250 USD per year (equivalent in UAH — according to the payment system’s rate at the time of payment);</li>
                    <li>Infinity Plan: 30 USD per month or 300 USD per year (equivalent in UAH — according to the payment system’s rate at the time of payment).</li>
                </ul>
                <p>5.2. Payment is made via the payment system integrated into the Platform, and the amount will be converted at the payment system’s rate on the day of payment.</p>
                <p>5.3. The Administration reserves the right to change the subscription fees, notifying the User in advance via the Platform.</p>

                <h3>6. Refund Procedure</h3>
                <p>6.1. In case of technical issues on the part of the Administration that led to the inability to use the Service, the User may request a partial or full refund.</p>
                <p>6.2. The request must be submitted within 14 calendar days from the moment the problem arose.</p>
                <p>6.3. Refunds are not issued if the User voluntarily stopped using the Service before the subscription period ended.</p>

                <h3>7. Liability of the Parties</h3>
                <p>7.1. The Administration is not liable for losses caused by:</p>
                <ul>
                    <li>Incorrect use of the Service by the User;</li>
                    <li>Problems with the User’s equipment or software;</li>
                    <li>Force majeure circumstances.</li>
                </ul>
                <p>7.2. The User is responsible for the accuracy of the information provided during registration.</p>

                <h3>8. Term of the Agreement</h3>
                <p>8.1. The Agreement enters into force upon payment of the subscription and is valid for the selected period (month or year).</p>
                <p>8.2. After the subscription period expires, the User may extend the term of the Agreement by making payment for the next period.</p>

                <h3>9. Other Terms</h3>
                <p>9.1. The Administration has the right to amend the terms of the Agreement. Amendments shall enter into force from the moment they are published.</p>
                <p>9.2. Continuing to use the Service after amendments means the User’s acceptance of the changes.</p>

                <h3>10. Contact Information</h3>
                <p>LLC “SUNPOINT IT SOLUTIONS”</p>
                <p>EDRPOU Code: 42783354</p>
                <p>Address: Serpova St., 11, Kyiv, Ukraine</p>
                <p>Email: sktech@sunpoint.com.ua</p>

                <p>This Agreement is public, indefinite, and remains in effect until its withdrawal by the Administrator.</p>
            </div>


        </Layout>
    )
}
export default PublicOfferEn;